import React from 'react';
import { Navigate } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '../store';
import { getDefaultLandingPath } from '../utils/defaultLandingPath';

/**
 * Opt-in gate for RogerEMR-only pages. Wrap the route element in App.tsx next
 * to that path — do not maintain a separate path allowlist. Pages that stay
 * available without RogerEMR simply omit this wrapper.
 */
const RogerEmrRouteGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, hasPermission, hasAnyPermission, hasFeatureFlag } = useStore(
    useShallow(state => ({
      user: state.user,
      hasPermission: state.hasPermission,
      hasAnyPermission: state.hasAnyPermission,
      hasFeatureFlag: state.hasFeatureFlag,
    }))
  );

  if (user?.agency?.is_rogeremr_enabled === true) {
    return <>{children}</>;
  }

  return (
    <Navigate
      to={getDefaultLandingPath({
        hasPermission,
        hasAnyPermission,
        hasFeatureFlag,
        isRogerEmrEnabled: false,
      })}
      replace
    />
  );
};

export default RogerEmrRouteGuard;
